import { IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import {
  MdOutlineThumbDown,
  MdOutlineThumbUp,
  MdThumbDown,
  MdThumbUp
} from 'react-icons/md';
import { ThreeDots } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { ActionStyle, FeedbackMessage, Footer } from './styles';

import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ROUTES from '../../../constants/routes';
import { Link } from 'react-router-dom';
import { deleteUnverifiedArticlesAPI } from '../../../api';
import deleteArticleFunction from '../../../lib/operationsOnKnowledgeArticles/published/deleteArticle';
import {
  createQna,
  getContentActions
} from '../../../redux/actions/contentActions';

const FooterComponent = ({
  changeIsEdit,
  changeArticle,
  saveArticle,
  isEdit,
  articleData,
  deleteArticle,
  addReaction,
  qna,
  answer,
  autosaveFn,
  handleOpenModal,
  handleModalProps,
  publishingArticle,
  handleShowOptions
}) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const loading = useSelector((state) => state.content.loading);
  const orgid = useSelector((state) => state.content.org_info?.org_data?._id);
  const [likeStatus, setLikeStatus] = useState(0);

  const handleEdit = async () => {
    !loading && changeIsEdit(true);
    let meta = { ...articleData?.meta };
    if (
      Object.keys(articleData?.meta).includes('published') &&
      articleData?.meta?.published === false
    ) {
      const data = {
        orgid,
        target: articleData?.meta?.target,
        access: articleData?.meta?.access,
        articleId: articleData?.articleId
      };
      await deleteUnverifiedArticlesAPI(data);
      delete meta['published'];
      delete meta['isReviewed'];
    } else if (
      Object.keys(articleData?.meta).includes('published') &&
      articleData?.meta?.published === true
    ) {
      delete meta['published'];
      delete meta['isReviewed'];
    }
    const newArticle = {
      ...articleData,
      meta
    };
    changeArticle(newArticle);
  };

  return publishingArticle ? (
    <Footer>
      <ThreeDots color="grey" height={50} width={50} ariaLabel="three-dots" />
    </Footer>
  ) : (
    <Footer>
      {isLoggedIn ? (
        <>
          <div>
            {isEdit ? (
              <>
                <Tooltip title="Cancel">
                  <IconButton
                    color="error"
                    onClick={() => {
                      if (!publishingArticle) {
                        changeArticle(articleData);
                        changeIsEdit(false);
                      }
                      handleShowOptions(false)
                    }}
                  >
                    <ClearOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Options">
                  <IconButton
                    color="primary"
                    onClick={() => handleShowOptions()}
                  >
                    <SettingsOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Save Article">
                  <IconButton
                    color="success"
                    onClick={() => [!publishingArticle && saveArticle(), handleShowOptions(false)]}
                  >
                    <SaveOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title="Edit Article">
                  <IconButton
                    sx={{ color: '#3F9820' }}
                    onClick={() => {
                      handleOpenModal();
                      handleModalProps({
                        actionButton: 'Edit',
                        message: 'Are you sure you want to edit this article?',
                        title: 'Edit Article',
                        actionFn: () => handleEdit()
                      });
                    }}
                  >
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Delete Article">
                  <IconButton
                    sx={{ color: '#C71D1A' }}
                    onClick={() => {
                      if (!publishingArticle) {
                        handleOpenModal();
                        handleModalProps({
                          actionButton: 'Delete',
                          message: 'Are you sure you want to delete this article?',
                          title: 'Delete Article',
                          actionFn: () => deleteArticle()
                        });
                      }
                    }}
                  >
                    <DeleteOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                
                <div style={{ marginLeft: '1rem', marginRight: '0.5rem' }}>
                  Was this helpful?
                </div>

                <div>
                  {likeStatus === 1 ? (
                    <Tooltip title="Undo">
                      <IconButton
                        sx={{ color: '#109648' }}
                        onClick={() => setLikeStatus(0)}
                      >
                        <ThumbUpIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Like">
                      <IconButton
                        onClick={() => {
                          addReaction('like');
                          setLikeStatus(1);
                        }}
                      >
                        <ThumbUpOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {likeStatus === -1 ? (
                    <Tooltip title="Undo">
                      <IconButton
                        sx={{ color: '#ED474A' }}
                        onClick={() => setLikeStatus(0)}
                      >
                        <ThumbDownIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Dislike">
                      <IconButton
                        onClick={() => {
                          addReaction('dislike');
                          setLikeStatus(-1);
                        }}
                      >
                        <ThumbDownOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>

                <div style={{ marginLeft: '1rem' }}>
                  <FeedbackMessage
                    style={{ color: likeStatus === 1 ? '#109648' : 'inherit' }}
                  >
                    {likeStatus === 1 ? (
                      'Glad it helped!'
                    ) : likeStatus === -1 ? (
                      <>
                        Sorry! Would you like to talk to
                        <Link
                          to={ROUTES.CUSTOMER_SERVICE}
                          style={{ marginLeft: '0.25rem' }}
                        >
                          customer service
                        </Link>
                        ?
                      </>
                    ) : (
                      ''
                    )}
                  </FeedbackMessage>
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <span>Was this helpful?</span>
          <div style={{ marginBottom: '-0.3rem' }}>
            {likeStatus === 1 ? (
              <MdThumbUp
                title="Undo"
                style={{
                  ...ActionStyle,
                  color: '#109648',
                  fontSize: '16px'
                }}
                onClick={() => setLikeStatus(0)}
              />
            ) : (
              <MdOutlineThumbUp
                title="Yes"
                style={{ ...ActionStyle, fontSize: '16px' }}
                onClick={() => {
                  addReaction('like');
                  setLikeStatus(1);
                }}
              />
            )}
            {likeStatus === -1 ? (
              <MdThumbDown
                title="Undo"
                style={{
                  ...ActionStyle,
                  color: '#ED474A',
                  fontSize: '16px'
                }}
                onClick={() => setLikeStatus(0)}
              />
            ) : (
              <MdOutlineThumbDown
                title="No"
                style={{ ...ActionStyle, fontSize: '16px' }}
                onClick={() => {
                  addReaction('dislike');
                  setLikeStatus(-1);
                }}
              />
            )}
          </div>
          <div style={{ marginLeft: '1rem' }}>
            <FeedbackMessage
              style={{ color: likeStatus === 1 ? '#109648' : 'inherit' }}
            >
              {likeStatus === 1 ? (
                'Glad it helped!'
              ) : likeStatus === -1 ? (
                <>
                  Sorry! Would you like to talk to
                  <Link
                    to={ROUTES.CUSTOMER_SERVICE}
                    style={{ marginLeft: '0.25rem' }}
                  >
                    customer service
                  </Link>
                  ?
                </>
              ) : (
                ''
              )}
            </FeedbackMessage>
          </div>
        </>
      )}
    </Footer>
  );
};

export default FooterComponent;
